import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ListService } from '@fry/lib/list';
import { BookingTypesSearch } from '@fry/booking/lib';


@Component({
    selector: 'eas-booking-types',
    templateUrl: './booking-types.component.html',
    providers: [
        ListService,
        BookingTypesSearch,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BookingTypesComponent {

  constructor(
  ) { }

}
